export const SousDispositif = [
  'BilanCompetences',
  'ValidationAcquisExperiences',
  'AbondementCpf',
  'TuteurMAitreApprentissage',
  'CleaSocleCompetence',
  'PDC',
  'ActionStandard',
  'Fne',
  'Fse',
  'PicIae',
  'FTJ',
] as const

export type SousDispositif = (typeof SousDispositif)[number]

/** Sous dispositifs disponibles à la créations */
export const SousDispositifDisponible: SousDispositif[] = [
    'BilanCompetences',
    'ValidationAcquisExperiences',
    'AbondementCpf',
    'TuteurMAitreApprentissage',
    'CleaSocleCompetence',
    'PDC',
    'ActionStandard',
    'Fne',
    'Fse',
    'PicIae',
    'FTJ',
] as const

export type SousDispositifDisponible = (typeof SousDispositifDisponible)[number]

export const SousDispositifLibelle: Record<SousDispositif, string> = {
  BilanCompetences: 'Bilan de compétences',
  ValidationAcquisExperiences: 'Validation des acquis de l’expérience',
  AbondementCpf: 'Abondement CPF',
  TuteurMAitreApprentissage: 'Tuteur / Maître d’apprentissage',
  CleaSocleCompetence: 'Cléa',
  PDC: 'Plan de développement des compétences',
  ActionStandard: 'Action standard',
  Fne: 'FNE',
  Fse: 'FSE',
  PicIae: 'PIC IAE',
  FTJ: 'FTJ',
} as const
